<template>
  <div class="main">
    <c-panel>
      <form-alimento :paramId="$route.params.id" v-on:onSubmitAlimento="onSubmitAlimento"></form-alimento>
    </c-panel>
  </div>
</template>
<script>
import formAlimento from "./form"

export default {
  methods: {
    onSubmitAlimento () {
      this.$router.push('/admin/merenda/alimento')
    }
  },
  components: { formAlimento }
}
</script>

